// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"43625ec2","713":"48022421","780":"2714f871"}[chunkId] + ".chunk.js";
};